import Http from '@/plugins/http.js';
import AppItemType from '@/models/app-item-type';
import FormViewType from '@/models/form-view-type';
import { IsNull } from '@/utils/utils';
import LoginService from '@/services/login.service.js';

export default {
    listUnfinishWorkItems(parameters) {
        return Http.POST(`api/Workflow/ListUnfinishWorkItems`, parameters);
    },

    listFinishWorkItems(parameters) {
        return Http.POST(`api/Workflow/ListFinishWorkItems`, parameters);
    },

    getListHeader(id) {
        return Http.GET(`api/list/GetListHeader/${id}`);
    },

    getListData(parameters) {
        return Http.POST(`api/list/GetListData`, parameters);
    },

    getSubListHeaders(parameters) {
        return Http.POST(`api/Form/GetSubListHeaders`, parameters);
    },
    getSubListData(parameters) {
        return Http.POST(`api/Form/GetSubListData`, parameters);
    },
    getLinkFormDataId(formCode, condition) {
        return Http.POST(`api/Form/GetLinkFormDataId/${formCode}`, condition);
    },
    // 获取按钮设置
    getButtonList(parameters) {
        return Http.GET('api/Form/GetButtonList/' + parameters);
    },
    /// 获取工作流场景
    getWorkItemScene(parameters) {
        const workItemSceneParameters = getWorkItemSceneParameters(parameters);
        return Http.POST('api/Workflow/GetWorkItemScene', workItemSceneParameters);
    },
    /// 是否是待办,true为待办，false为已办
    isUnfinish(parameters) {
        const workItemSceneParameters = getWorkItemSceneParameters(parameters);
        return Http.POST('api/Workflow/IsUnfinish', workItemSceneParameters);
    },
    /// 获取表单信息
    getFormInfo(parameters) {
        const formScene = getFormScene(parameters);
        return Http.POST('api/Form/GetFormInfo', formScene);
    },
    /// 获取表单信息
    getFormInfoByReltable(parameters, reltable) {
        const formScene = getFormScene(parameters, reltable);
        return Http.POST(`api/Form/GetFormInfo`, formScene);
    },
    //获取九宫格应用
    getApplicate() {
        return Http.GET('api/App/GetListMyAccessApps');
    },
    //获取表单按钮
    getFormButtons(parameters) {
        const formScene = getButtonScene(parameters);
        return Http.POST('api/Form/GetFormButtonList', formScene);
    },
    //获取待办待阅数量
    getDataCount(inAppCode = null) {
        return Http.GET(
            inAppCode ? `/api/Workflow/GetWorkCount/${inAppCode}` : '/api/Workflow/GetWorkCount'
        );
    },
    //获取代办信息
    getCartUnfinishWorkItems(
        BelongsApp,
        PagingInfo,
        cardType = 0,
        SearchCondition = {},
        extra = {
            cancelable: false,
            source: null,
        }
    ) {
        if (extra && extra.cancelable) {
            extra.source = Http.getCancelableSource();
        }
        return Http.POST(
            'api/Workflow/CartUnfinishWorkItems',
            {
                BelongsApp,
                PagingInfo,
                cardType,
                SearchCondition,
            },
            null,
            false,
            extra.source
        );
    },
    //获取已办信息
    getCartFinishWorkItems(
        BelongsApp,
        PagingInfo,
        cardType = 0,
        SearchCondition = {},
        extra = {
            cancelable: false,
            source: null,
        }
    ) {
        if (extra && extra.cancelable) {
            extra.source = Http.getCancelableSource();
        }
        return Http.POST(
            'api/Workflow/CartFinishWorkItems',
            {
                BelongsApp,
                PagingInfo,
                cardType,
                SearchCondition,
            },
            null,
            false,
            extra.source
        );
    },
    //获取待阅信息
    getCartUnfinishCirculateItems(
        BelongsApp,
        PagingInfo,
        cardType = 1,
        SearchCondition = {},
        extra = {
            cancelable: false,
            source: null,
        }
    ) {
        if (extra && extra.cancelable) {
            extra.source = Http.getCancelableSource();
        }
        return Http.POST(
            'api/Workflow/CartUnfinishCirculateItems',
            {
                BelongsApp,
                PagingInfo,
                cardType,
                SearchCondition,
            },
            null,
            false,
            extra.source
        );
    },
    //获取已阅信息
    getCartFinishCirculateItems(
        BelongsApp,
        PagingInfo,
        cardType = 1,
        SearchCondition = {},
        extra = {
            cancelable: false,
            source: null,
        }
    ) {
        if (extra && extra.cancelable) {
            extra.source = Http.getCancelableSource();
        }
        return Http.POST(
            'api/Workflow/CartFinishCirculateItems',
            {
                BelongsApp,
                PagingInfo,
                cardType,
                SearchCondition,
            },
            null,
            false,
            extra.source
        );
    },
    /// 表单提交
    submitFormData(parameters) {
        return Http.POST('api/Form/SaveFormInfo', parameters);
    },
    // 删除表单
    deleteFormData(parameters) {
        return Http.POST('/api/Form/SaveFormInfo', parameters);
    },
    collectionFormData(parameters) {
        return Http.POST('/api/Form/SaveFormInfo', parameters);
    },
    /**
     * 修改文件列表文件路径
     * @param {*} formCode
     * @param {*} dataId
     * @param {*} fileName
     */
    updateFilePath(formCode, dataId, fileName) {
        return Http.GET(`api/List/UpdateFilePath/${formCode}/${dataId}/${fileName}`);
    },
    //获取子表
    getSubList(params) {
        return Http.POST('/api/Form/GetSubList', params);
    },
    //获取带分页的子表
    getSubListPage(params) {
        return Http.POST('/api/Form/GetSubListPage', params);
    },
    //获取子表
    getSubCommentList(params) {
        return Http.POST('/api/Form/GetSubCommentList', params);
    },
    getSubDataSourceList(params) {
        return Http.POST('/api/Form/GetSubDataSourceList', params);
    },
    getSubDataSourceListPage(params) {
        return Http.POST('/api/Form/GetSubDataSourceListPage', params);
    },
    /**
     *  检查下一步是否有审批人
     * @param {*} parameters 需要的参数
     * @param {*} isReturnBtn  是否为驳回
     */
    getMustSelectPreson(parameters, isReturnBtn = false) {
        if (!isReturnBtn) {
            return Http.POST('api/Form/MustSelectFlowPerson', parameters);
        } else {
            return Http.POST('api/Form/MustSelectFlowPersonForReturn', parameters);
        }
    },
    defineSelectFlowPerson(parameters) {
        return Http.POST('api/Form/DefineSelectFlowPerson', parameters);
    },
    GetFormHistoryVersion(formCode) {
        return Http.GET(`api/Form/GetFormHistoryVersion/${formCode}`);
    },
    IsSyncFormVersion(formCode) {
        return Http.GET(`api/Form/IsSyncFormVersion/${formCode}`);
    },
    EnabledFormVersion(formCode) {
        return Http.GET(`api/Form/EnabledFormVersion/${formCode}`);
    },
    FormVersionDataSync(formCode) {
        return Http.GET(`api/Form/FormVersionDataSync/${formCode}`);
    },
    PublishedFormVersion(formCode) {
        return Http.GET(`api/Form/PublishedFormVersion/${formCode}`);
    },
    ResumeVersion(formCode, versionId) {
        return Http.GET(`api/Form/ResumeVersion/${formCode}/${versionId}`);
    },
    //转发
    getChildUsers(parameters) {
        return Http.POST('api/Organization/GetChildUsers', parameters);
    },
    // 删除子表数据
    deleteSubData(subFormCode, dataId) {
        return Http.GET(`/api/Form/DeleteSubData/${subFormCode}/${dataId}`);
    },
    // 批量删除子表数据
    batchDeleteSubData(subFormCode, dataIds = []) {
        return Http.POST(`/api/Form/BatchDeleteSubData/${subFormCode}`, dataIds);
    },
    //获取应用场景列表
    getSearchConditionList(itemCode) {
        return Http.GET(`api/List/GetSearchConditionList/${itemCode}`);
    },
    //删除场景
    deleteSearchScene(itemCode) {
        return Http.POST(`api/List/DeleteSearchCondition`, itemCode);
    },
    //保存场景管理设置
    saveSelfSeachConditions(saveSelfSeachConditions) {
        return Http.POST(`api/List/SaveSelfSeachConditions`, saveSelfSeachConditions);
    },
    //设置默认场景
    setSelfConditionDefault(itemCode, systemOwned, objectID, conditionName) {
        return Http.GET(
            `api/List/SetSelfConditionDefault/${itemCode}/${systemOwned}/${objectID}/${conditionName}`
        );
    },
    //编辑场景
    editSearchScene(searchOpt, itemCode) {
        return Http.POST(`api/List/UpdateSearchCondition/${itemCode}`, searchOpt);
    },
    //添加场景
    addSearchScene(searchOpt, itemCode) {
        return Http.POST(`api/List/AddSearchCondition/${itemCode}`, searchOpt);
    },
    /**获取表单布局 */
    getFormLayout(formCode, isVersion) {
        if (isVersion) return Http.GET(`api/Form/GetFormLayout/${formCode}/${isVersion}`);
        else return Http.GET(`api/Form/GetFormLayout/${formCode}`);
    },
    /**获取表单布局(集合) */
    getFormLayouts(formCodes, bizOjbectSchemaCode) {
        var str = bizOjbectSchemaCode ? '/' + bizOjbectSchemaCode : '';
        return Http.POST(`api/Form/GetFormLayouts` + str, formCodes);
    },
    /**保持表单布局 */
    saveFormLayout(param) {
        return Http.POST(`api/Form/SaveFormLayout`, param);
    },
    /**保持表单布局(集合) */
    saveFormLayouts(param) {
        return Http.POST(`api/Form/SaveFormLayouts`, param);
    },
    getFormControls(formCode) {
        return Http.GET(`api/Form/GetFormControls/${formCode}`);
    },
    /**
     * 获取数据源
     * @param formCode
     * @param filterDelFields 是否过滤已被删除的数据源字段
     */
    getDataSource(formCode, filterDelFields = true) {
        return Http.GET(`api/DataSource/GetDataSource` + '/' + formCode + '/' + filterDelFields);
    },

    /**
     * 获取列表设置
     * @param {string} formCode
     */
    getListSetting(formCode) {
        return Http.GET(`api/list/GetListSetting/` + formCode);
    },

    /**
     * 获取系统字段
     */
    getDefalutType() {
        return Http.GET(`api/DataSource/GetDefaultType`);
    },

    /**
     * 表单打印导出Word
     */
    printAsWord(param, exportWord = false) {
        return Http.POST(`api/List/PrintSheet/${exportWord}`, param, 'blob');
    },

    /**是否存在附件 */
    existFile(fileId) {
        return Http.GET(`api/Form/ExistFile/${fileId}`);
    },
    // 转换内嵌网页占位符方法
    convertWebSiteUrl(urlStr, objectId) {
        // 替换自定义链接的占位符等
        if (urlStr.indexOf('{{') > 0) {
            let start = urlStr.indexOf('{{');
            let end = urlStr.indexOf('}}');
            let str = urlStr.substring(start, end + 2);
            let value = getWebSiteStrValue(str, objectId);
            urlStr = urlStr.replace(str, value);
            return this.convertWebSiteUrl(urlStr, objectId);
        }
        return urlStr;
    },
    // 关联子表数据
    saveRelSelectSubData(formCode, formDataId, relCode, relObjectId) {
        return Http.GET(
            `api/Form/SaveRelSelectSubData/${formCode}/${formDataId}/${relCode}/${relObjectId}`
        );
    },
    // 清空子表关联控件导入的数据
    removeSubRelDataByParentID(subFormCode, parentId) {
        return Http.GET(`api/Form/RemoveSubRelDataByParentID/${subFormCode}/${parentId}`);
    },
    // 关联子表数据
    SaveRelSelectSubDataBySubrelfield(formCode, formDataId, relObjectId, subrelfield) {
        return Http.POST(
            `api/Form/SaveRelSelectSubDataBySubrelfield/${formCode}/${formDataId}/${relObjectId}`,
            subrelfield
        );
    },

    // OCR识别相关
    /**
     * OCR识别支持的类型
     */
    getOcrTypeList() {
        return Http.GET(`api/Form/GetOcrTypeList`);
    },
    /**
     * OCR 根据类型获取类型属性
     */
    getOcrPropertyFieldsByType(ocrType) {
        return Http.GET(`api/Form/GetOcrPropertyFieldsByType/${ocrType}`);
    },
    getAppFunctionItemByFormAddRole(appcode = '') {
        return Http.GET(`api/app/GetAppFunctionItemByFormAddRole/${appcode}`);
    },
    getAppByFormAddRole() {
        return Http.GET(`api/app/GetAppByFormAddRole`);
    },
    getAppByFormWorkFlowRole() {
        return Http.GET(`api/App/GetAppByFormWorkFlowRole`);
    },
    getAppFunctionItemByFormWorkFlowRole() {
        return Http.GET(`api/App/GetAppFunctionItemByFormWorkFlowRole`);
    },
    //传阅流程信息列表
    GetDataCirculates(flowId, pagingInfo) {
        return Http.POST(`api/Workflow/GetDataCirculates/${flowId}`, pagingInfo);
    },

    getRelSubtableDatas(formcode, relFormCode, parentDataId, relDataId, code) {
        return Http.GET(
            `api/Form/GetRelSelectDatas/${formcode}/${relFormCode}/${parentDataId}/${relDataId}/${code}`
        );
    },
    // 暂停传阅流程
    pauseOnCirculate(circulateId, dataId) {
        return Http.GET(`api/Workflow/PauseOnCirculate/${circulateId}/${dataId}`);
    },
    getCancelButtonText(formCode, flowId) {
        return Http.GET(`api/Workflow/GetCancelButtonText/${formCode}/${flowId}`);
    },
};

/// 获取工作流场景参数
function getWorkItemSceneParameters(params) {
    return {
        UserId: LoginService.userInfo.ObjectID,
        FormCode: params.isSubForm ? params.subCode : params.formCode,
        DataId: params.isSubForm ? params.subDataID : params.dataId,
        FlowId: params.flowId,
        CardType: params.cardType ? params.cardType : 0,
    };
}

/// 获取表单场景
function getFormScene(params, reltable = '') {
    let type = null;
    const appItemType = params.isSubForm ? params.subAppItemType : params.appItemType;
    if (appItemType === AppItemType.ViewList) {
        // 视图
        type = 'S2Cloud.SmartFlow.Sheet.ViewFormScene,S2Cloud.SmartFlow';
    } else if (params.isWorkFlow) {
        // 工作流
        switch (params.formViewType) {
            case FormViewType.Add:
                {
                    // 新增
                    if (params.isSubForm) {
                        type = 'S2Cloud.SmartFlow.Sheet.WorkFlowSubAddFormScene,S2Cloud.SmartFlow';
                    } else {
                        type = 'S2Cloud.SmartFlow.Sheet.WorkFlowMainAddFormScene,S2Cloud.SmartFlow';
                    }
                }
                break;
            case FormViewType.Edit:
                {
                    // 编辑
                    if (params.isSubForm) {
                        type = 'S2Cloud.SmartFlow.Sheet.WorkFlowSubEditFormScene,S2Cloud.SmartFlow';
                    } else if (params.state === 0) {
                        type =
                            'S2Cloud.SmartFlow.Sheet.WorkFlowMainTempSaveFormScene,S2Cloud.SmartFlow';
                    } else {
                        type =
                            'S2Cloud.SmartFlow.Sheet.WorkFlowMainUnFinishFormScene,S2Cloud.SmartFlow';
                    }
                }
                break;
            case FormViewType.View:
                {
                    // 查看
                    if (params.isSubForm) {
                        type = 'S2Cloud.SmartFlow.Sheet.WorkFlowSubViewFormScene,S2Cloud.SmartFlow';
                    } else if (params.state === 0) {
                        type =
                            'S2Cloud.SmartFlow.Sheet.WorkFlowMainTempSaveViewFormScene,S2Cloud.SmartFlow';
                    } else {
                        type =
                            'S2Cloud.SmartFlow.Sheet.WorkFlowMainUnFinishViewFormScene,S2Cloud.SmartFlow';
                    }
                }
                break;
            default:
                break;
        }
    } else {
        // 非工作流
        switch (params.formViewType) {
            case FormViewType.Add:
                {
                    // 新增
                    if (params.isSubForm) {
                        type = 'S2Cloud.SmartFlow.Sheet.NormalSubAddFormScene,S2Cloud.SmartFlow';
                    } else {
                        type = 'S2Cloud.SmartFlow.Sheet.NormalMainAddFormScene,S2Cloud.SmartFlow';
                    }
                }
                break;
            case FormViewType.Edit:
                {
                    // 编辑
                    if (params.isSubForm) {
                        type = 'S2Cloud.SmartFlow.Sheet.NormalSubEditFormScene,S2Cloud.SmartFlow';
                    } else {
                        type = 'S2Cloud.SmartFlow.Sheet.NormalMainEditFormScene,S2Cloud.SmartFlow';
                    }
                }
                break;
            case FormViewType.View:
                {
                    // 查看
                    if (params.isSubForm) {
                        type = 'S2Cloud.SmartFlow.Sheet.NormalSubViewFormScene,S2Cloud.SmartFlow';
                    } else {
                        type = 'S2Cloud.SmartFlow.Sheet.NormalMainViewFormScene,S2Cloud.SmartFlow';
                    }
                }
                break;
            default:
                break;
        }
    }
    if (reltable != '') {
        type = 'S2Cloud.SmartFlow.Sheet.WorkFlowDatasourceSubViewFormScene,S2Cloud.SmartFlow';
    }
    const formScene = {
        $type: type,
        FormCode: params.formCode,
        DataId: params.isSubForm ? params.subDataID : params.dataId,
        CardType: params.cardType,
        IsAction: params.IsAction ? true : false,
    };

    if (
        params.isWorkFlow &&
        ((!params.isSubForm && params.formViewType !== FormViewType.Add) || params.isSubForm)
    ) {
        formScene.FlowId = params.flowId;
    }

    if (params.isSubForm) {
        formScene.SubCode = params.subCode;
    }
    if (reltable) {
        formScene.Reltable = reltable;
    }
    return formScene;
}

/// 获取表单按钮场景
function getButtonScene(params) {
    const buttonScene = {};
    const appItemType = params.isSubForm ? params.subAppItemType : params.appItemType;
    if (appItemType === AppItemType.ViewList) {
        // 视图
        buttonScene.$type = 'S2Cloud.SmartFlow.Sheet.ViewListFormViewScene,S2Cloud.SmartFlow';
    } else if (params.isWorkFlow && !params.isSubForm) {
        // 主表工作流
        switch (params.formViewType) {
            case FormViewType.Add:
                {
                    // 新增
                    buttonScene.$type = 'S2Cloud.SmartFlow.Sheet.WFFormAddScene,S2Cloud.SmartFlow';
                }
                break;
            case FormViewType.Edit:
                {
                    // 编辑
                    if (params.state === 0) {
                        buttonScene.$type =
                            'S2Cloud.SmartFlow.Sheet.WFFormEditTempsaveScene,S2Cloud.SmartFlow';
                        buttonScene.FlowId = params.flowId;
                        buttonScene.WorkItemId = params.workItemId;
                        buttonScene.WorkflowVersion = params.workflowVersion;
                    } else {
                        if(params.cardType==1){
                            //待阅的 ，走查看
                            buttonScene.$type ='S2Cloud.SmartFlow.Sheet.WFFormViewUnfinishScene,S2Cloud.SmartFlow';
                        }else{
                            buttonScene.$type ='S2Cloud.SmartFlow.Sheet.WFFormEditUnfinishScene,S2Cloud.SmartFlow';    //待办编辑
                        }
                        buttonScene.FlowId = params.flowId;
                        buttonScene.WorkItemId = params.workItemId;
                        buttonScene.WorkflowVersion = params.workflowVersion;
                    }
                }
                break;
            case FormViewType.View:
                {
                    // 查看
                    if (params.state === 0) {
                        if (IsNull(params.workItemId)) {
                            buttonScene.$type =
                                'S2Cloud.SmartFlow.Sheet.WFFormViewFinishScene,S2Cloud.SmartFlow';
                        } else {
                            buttonScene.$type =
                                'S2Cloud.SmartFlow.Sheet.WFFormViewTempsaveScene,S2Cloud.SmartFlow';
                        }
                    } else if (params.isUnfinish) {
                        buttonScene.$type =
                            'S2Cloud.SmartFlow.Sheet.WFFormViewUnfinishScene,S2Cloud.SmartFlow';
                        buttonScene.FlowId = params.flowId;
                    } else {
                        buttonScene.$type =
                            'S2Cloud.SmartFlow.Sheet.WFFormViewFinishScene,S2Cloud.SmartFlow';
                    }
                    //版本号，传阅锁需要
                    buttonScene.WorkflowVersion = params.workflowVersion;
                }
                break;
            default:
                break;
        }
    } else if (params.isMailList) {
        switch (params.formViewType) {
            case FormViewType.Add:
                {
                    buttonScene.$type =
                        'S2Cloud.SmartFlow.Sheet.MailListFormEditScene,S2Cloud.SmartFlow';
                }
                break;
            case FormViewType.View:
                console.log(params);
                {
                    if (params.emailType === 'InBox') {
                        buttonScene.$type =
                            'S2Cloud.SmartFlow.Sheet.MailListFormViewScene,S2Cloud.SmartFlow';
                    } else if (params.emailType === 'OutBox') {
                        buttonScene.$type =
                            'S2Cloud.SmartFlow.Sheet.MailListFormOutDataViewScene,S2Cloud.SmartFlow';
                    }
                }
                break;
            case FormViewType.Edit:
                {
                    if (params.emailType === 'DraftBox') {
                        buttonScene.$type =
                            'S2Cloud.SmartFlow.Sheet.MailListFormDraftScene,S2Cloud.SmartFlow';
                    }
                }
                break;
        }
    } else {
        // 非工作流
        switch (params.formViewType) {
            case FormViewType.Add:
                {
                    // 新增
                    if (params.isSubForm) {
                        if (params.isEditByAdmin) {
                            buttonScene.$type =
                                'S2Cloud.SmartFlow.Sheet.AdminNormalSubFormEditScene,S2Cloud.SmartFlow';
                        } else {
                            buttonScene.$type =
                                'S2Cloud.SmartFlow.Sheet.NormalSubFormEditScene,S2Cloud.SmartFlow';
                        }
                    } else {
                        buttonScene.$type =
                            'S2Cloud.SmartFlow.Sheet.NormalFormAddScene,S2Cloud.SmartFlow';
                    }
                }
                break;
            case FormViewType.Edit:
                {
                    // 编辑
                    if (params.isSubForm) {
                        if (params.isEditByAdmin) {
                            buttonScene.$type =
                                'S2Cloud.SmartFlow.Sheet.AdminNormalSubFormEditScene,S2Cloud.SmartFlow';
                        } else {
                            buttonScene.$type =
                                'S2Cloud.SmartFlow.Sheet.NormalSubFormEditScene,S2Cloud.SmartFlow';
                        }
                    } else {
                        if (params.isEditByAdmin) {
                            buttonScene.$type =
                                'S2Cloud.SmartFlow.Sheet.AdminNormalFormEditScene,S2Cloud.SmartFlow';
                        } else {
                            buttonScene.$type =
                                'S2Cloud.SmartFlow.Sheet.NormalFormEditScene,S2Cloud.SmartFlow';
                        }
                    }
                }
                break;
            case FormViewType.View:
                {
                    // 查看
                    if (params.isSubForm) {
                        buttonScene.$type =
                            'S2Cloud.SmartFlow.Sheet.NormalSubFormViewScene,S2Cloud.SmartFlow';
                    } else {
                        buttonScene.$type =
                            'S2Cloud.SmartFlow.Sheet.NormalFormViewScene,S2Cloud.SmartFlow';
                    }
                }
                break;
            default:
                break;
        }
    }

    buttonScene.FormCode = params.formCode;
    buttonScene.DataId = params.isSubForm ? params.subDataID : params.dataId;
    buttonScene.WorkItemId = params.workItemId;
    if (params.isSubForm) {
        buttonScene.SubCode = params.subCode;
    }

    return buttonScene;
}

//  todo  有问题 待完善 获取占位符内容
function getWebSiteStrValue(str, objectId) {
    str = str.replace('{{', '');
    str = str.replace('}}', '');
    let retstr = '';
    if (str.indexOf('f_') === 0) {
        // this.$refs["form-view"].dataFormItems.forEach(element => {
        //   if (element.code === str) {
        //     switch (element.componentKey) {
        //       case "DepartmentOrg":
        //         if (element.value && element.value.length > 0 && element.value[0].Id) {
        //           retstr = element.value[0].Id;
        //         }
        //         break;
        //       case "Person":
        //         if (element.value && element.value.length > 0 && element.value[0].Id) {
        //           retstr = element.value[0].Id;
        //         }
        //         break;
        //       default:
        //         retstr = element.value;
        //         break;
        //     }
        //   }
        // });
    } else {
        switch (str) {
            case 'ObjectId':
                retstr = objectId;
                break;
            case 'CurrUser':
                retstr = LoginService.userInfo.ObjectID;
                break;
            case 'CurrUserCode':
                retstr = LoginService.userInfo.Code;
                break;
            default:
                retstr = '';
                break;
        }
    }
    return retstr;
}
